import { IAddress } from "../Addresses"
import { IPhoneNumber } from "../Contacts"
import { TMedia } from "../Media"
import { IListResponse, XHRInstance } from "@sembark-travel/xhr"
import { IUser } from "../Users"
import { TTeam } from "../Teams"
import { T_BankAccount } from "../BankAccounts"

export type TTripDestination = {
	id: number
	name: string
	short_name: string
	description?: string
	trips_count?: number
	converted_trips_count?: number
	in_progress_trips_count?: number
	media_url?: string | null
	thumb_image_url?: string | null
	latest_media?: TMedia | null
	banner_latest_media?: TMedia | null
	non_branding_banner_latest_media?: TMedia | null
	reviews_latest_media?: TMedia | null
	currency: string
	phone_numbers?: Array<IPhoneNumber<TTripDestination>>
	addresses?: Array<IAddress>
	created_at: string
	created_by?: IUser
	bank_accounts?: T_BankAccount[]
	deleted_at?: string
	deleted_by?: IUser
	updated_at?: string
	updated_by?: IUser
	min_child_age: number
	max_child_age: number
	hotel_checkin_at: string
	hotel_checkout_at: string
	teams?: TTeam[]
	preload_data_exists?: boolean
	preload_data_status?: "in_progress" | "completed" | "failed" | null
	preload_data_opted?: 0 | 1
}

export function tripDestinationsXHR(xhr: XHRInstance) {
	return {
		async get(params?: unknown): Promise<IListResponse<TTripDestination>> {
			return xhr.get("/trip-destinations", { params }).then((resp) => resp.data)
		},
	}
}
